var React = require('react');

function TwitterInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21.186 7.635c0-.219-.004-.437-.014-.653.962-.713 2.169-1.602 2.828-2.615a9.63 9.63 0 0 1-2.828.795 5.046 5.046 0 0 0 2.166-2.792 9.728 9.728 0 0 1-3.127 1.225A4.862 4.862 0 0 0 16.617 2c-2.72 0-4.925 2.261-4.925 5.048 0 .397.044.782.128 1.152-4.092-.212-7.721-2.22-10.15-5.276a5.134 5.134 0 0 0-.666 2.538 5.08 5.08 0 0 0 2.19 4.203 4.796 4.796 0 0 1-2.23-.632v.065c0 2.445 1.697 4.487 3.95 4.95a4.816 4.816 0 0 1-2.224.086c.627 2.006 2.445 3.466 4.6 3.507A9.724 9.724 0 0 1 0 19.732 13.689 13.689 0 0 0 7.548 22c9.057 0 13.638-7.694 13.638-14.365z","fill":"currentColor","fillRule":"evenodd"}));
}

TwitterInline.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = TwitterInline;

TwitterInline.default = TwitterInline;
